var accordion_category_title = document.querySelectorAll(".accordion-title");
var accordion_category_question = document.querySelectorAll(
  ".accordion-question"
);

function removeCClass(element) {
  element.classList.remove("active");
}

function addCClass(element) {
  element.classList.add("active");
}

function accordionFunction(heading, loopElement, block_wrapper) {
  heading.forEach(function (element) {
    removeCClass(element.closest(block_wrapper));
  });
  var closest_parent = loopElement.closest(block_wrapper);
  closest_parent.classList.add("active");
}

accordion_category_title.forEach(function (element) {
  var block_wrapper = ".accordion-block-wrapper";
  element.addEventListener("click", function () {
    accordionFunction(accordion_category_title, element, block_wrapper);
  });
});

accordion_category_question.forEach(function (element) {
  element.addEventListener("click", function () {
    var block_wrapper = ".accordion-block-faq";
    accordionFunction(accordion_category_question, element, block_wrapper);
  });
});
